export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q01_a.d6c2cd29.png";